module.exports = __webpack_public_path__ + "static/media/img-cover-01.50304692.png";